import { useEffect, useState } from "react";
import { useAppDispatch } from "../../store/hooks/dispatch.hook";
import { setFonVisiable } from "../../store/state/all/all.slice";
import { setDefaultValueClients } from "../../store/state/clients/clients.slice";
import { setDefaultValueFinance } from "../../store/state/finance/finance.slice";
import { setDefaultValueGroups } from "../../store/state/groups/groups.slice";

type ReturnType = () => NodeJS.Timeout;

export default function useDefaultSettings(delay: number = 0): ReturnType {
    const dispatch = useAppDispatch();

    return () => setTimeout(() => {
        dispatch(setDefaultValueGroups({
            searchCleints: true,
            searchGroups: true,
            selectedService: true,
            searchClientsFormVisiable: true,
            createClientFormVisiable: true,
            addStudentToGroupFormVisiable: true,
            showStudentVisitForm: true
        }));

        dispatch(setDefaultValueClients({
            visiableCommentForm: true,
            visiableTransactionForm: true,
            clientsPages: false,
            transactionsPages: true
        }));

        dispatch(setDefaultValueFinance({
            visiableAddForm: true,
            visiableExchangeForm: true,
            visiablePaymentForm: true,
            counterpartis: true,
            counteragents: true,
        }));
    }, delay);
}